import { isUndefined } from 'lodash';
import SlaTag from 'components/atoms/tags/SlaTag';
import DoNotCallTag from 'components/atoms/tags/DoNotCallTag';
import EmailUnsubscribedTag from 'components/atoms/tags/EmailUnsubscribedTag';
import PcmTag from 'components/atoms/tags/PcmTag';
import { useTranslation } from 'react-i18next';
import CopyableText from 'components/atoms/buttons/copyable-text';
import CopyIcon from 'components/atoms/icons/copyIcon';
import SalesForceIntegrationTag from 'components/atoms/tags/sales-force-integration-tag';

import s from '../styles.module.scss';

import type { FC } from 'react';

interface TitleProps {
  fullName: string;
  birthDate: string;
  patientGuid: string;
  sla?: number;
  isShowDoNotCallTag?: boolean;
  isShowEmailTag?: boolean;
  pcmStatus?: boolean;
  showSalesForceIntegration?: boolean;
}

const Title: FC<TitleProps> = ({
  fullName,
  birthDate,
  sla,
  isShowDoNotCallTag,
  isShowEmailTag,
  pcmStatus,
  showSalesForceIntegration,
  patientGuid,
}) => {
  const { t } = useTranslation();
  return (
    <div className={s['title-wrapper']}>
      <div>
        <h4 className={s.title} data-cy="patient-name">
          {fullName}
        </h4>
        <div className={s['tags-wrapper']}>
          {!isUndefined(sla) && <SlaTag hours={sla} small />}
          {isShowDoNotCallTag && <DoNotCallTag small />}
          {isShowEmailTag && <EmailUnsubscribedTag small />}
          {pcmStatus && <PcmTag small />}
          {showSalesForceIntegration && <SalesForceIntegrationTag small />}
        </div>
      </div>
      <p className={s.date} data-cy="patient-birthday-date">
        {birthDate}
      </p>
      <p data-cy="patient-id" className={s['patient-id']}>
        <span>{t('labels.patientID')}:</span>{' '}
        <CopyableText value={patientGuid} icon={<CopyIcon />} />
      </p>
    </div>
  );
};
export default Title;
